<div class="grid-item">
  <div class="grid-item-top"></div>
  <div class="grid-item-bottom">
    <div class="loading-item-data"></div>
    <div class="loading-item-data medium"></div>
    <div class="loading-item-data"></div>
    <div class="loading-item-data short"></div>
  </div>
</div>
